import React from 'react';

const TailwindTest = () => {
  return (
    <div className="p-8 bg-red-500 text-white">
      <h1 className="text-4xl font-bold mb-4">Tailwind Test</h1>
      <p className="text-lg">If you see RED background and white text, Tailwind is working!</p>
      <div className="mt-4 p-4 bg-blue-500">
        This should be BLUE
      </div>
      <div className="mt-4 p-4 bg-green-500">
        This should be GREEN
      </div>
      <div className="mt-4 grid grid-cols-3 gap-4">
        <div className="bg-yellow-500 p-4">Grid 1</div>
        <div className="bg-purple-500 p-4">Grid 2</div>
        <div className="bg-pink-500 p-4">Grid 3</div>
      </div>
    </div>
  );
};

export default TailwindTest;
